import React, { useState } from 'react';

import { Row, Col, Space } from 'antd';

import {
  FormEditButton,
  FormDeleteButton,
  FormCancelButton,
  CustomNotification,
} from 'common/components';
import DownloadFolderModal from 'common/components/modal-download-folder/DownloadFolderModal';

import { useGetScheduleDownloadDetailQuery } from 'hooks/folders/queries';
import {
  useDeleteScheduleDownload,
  useCancelScheduleDownload,
  useUpdateScheduleDownload,
} from 'hooks/folders';

const ManageScheduleDownloadToolbar = (props = {}) => {
  const { selectedSchedule, setSelectedSchedule, folderId } = props || {};

  const [downloadModalVisible, setDownloadModalVisible] = useState(false);

  const { data: schedulerDetail } = useGetScheduleDownloadDetailQuery({
    scheduleId: selectedSchedule?.id,
    enabled: selectedSchedule?.id && downloadModalVisible,
  });

  const { downloadSetting, ...restSchedulerDetail } = schedulerDetail || {};

  const { updateScheduleDownload } = useUpdateScheduleDownload({ folderId });
  const { deleteScheduleDownload, showDeleteConfirm, showDeleteMessage } =
    useDeleteScheduleDownload({ folderId });
  const { cancelScheduleDownload, showCancelConfirm, showCancelMessage } =
    useCancelScheduleDownload({
      folderId,
    });

  const showDownloadModal = () => {
    setDownloadModalVisible(true);
  };

  const closeDownloadModal = () => {
    setDownloadModalVisible(false);
  };

  const updateScheduler = async (formParams) => {
    try {
      const params = { id: selectedSchedule?.id, ...formParams };
      const response = await updateScheduleDownload.mutateAsync(params);

      if (response?.isSuccess) {
        CustomNotification.success('Update Scheduler Successfully');

        return Promise.resolve({ isSuccess: true });
      } else CustomNotification.error('Fail to update scheduler');
    } catch (error) {
      CustomNotification.error('Fail to update scheduler');
    }
  };

  const onClickEditBtn = () => {
    showDownloadModal();
  };

  const onClickDeleteBtn = async () => {
    const confirmed = await showDeleteConfirm();

    if (!confirmed?.ok) return;

    try {
      const result = await deleteScheduleDownload.mutateAsync({
        id: selectedSchedule?.id,
      });

      if (result.isSuccess) {
        setSelectedSchedule(null);
        return showDeleteMessage('success');
      }

      showDeleteMessage('error', result?.message);
    } catch (error) {
      showDeleteMessage('error');
    }
  };

  const onClickCancelBtn = async () => {
    const confirmed = await showCancelConfirm();

    if (!confirmed?.ok) return;

    try {
      const result = await cancelScheduleDownload.mutateAsync({
        id: selectedSchedule?.id,
      });

      if (result.isSuccess) {
        setSelectedSchedule(null);
        return showCancelMessage('success');
      }

      showCancelMessage('error', result?.message);
    } catch (error) {
      showCancelMessage('error');
    }
  };

  const cancelButtonDisabled =
    !selectedSchedule ||
    selectedSchedule?.status?.toLowerCase() !== 'active' ||
    deleteScheduleDownload?.isLoading;

  const editButtonDisabled =
    !selectedSchedule ||
    selectedSchedule?.status?.toLowerCase() !== 'active' ||
    deleteScheduleDownload?.isLoading ||
    cancelScheduleDownload?.isLoading;

  return (
    <Row>
      <Col flex={1}></Col>
      <Col flex={0}>
        <Space>
          <FormEditButton
            disabled={editButtonDisabled}
            onClick={onClickEditBtn}
          />
          <FormCancelButton
            text='Cancel Schedule'
            disabled={cancelButtonDisabled}
            loading={cancelScheduleDownload?.isLoading}
            onClick={onClickCancelBtn}
          />
          <FormDeleteButton
            disabled={!selectedSchedule || cancelScheduleDownload?.isLoading}
            loading={deleteScheduleDownload?.isLoading}
            onClick={onClickDeleteBtn}
          />
        </Space>
      </Col>
      <DownloadFolderModal
        visible={downloadModalVisible}
        folderId={folderId}
        initialStep={1}
        schedulerData={{ downloadSetting, scheduleSetup: restSchedulerDetail }}
        closeModal={closeDownloadModal}
        updateScheduler={updateScheduler}
      />
    </Row>
  );
};

export default ManageScheduleDownloadToolbar;
